// extracted by mini-css-extract-plugin
var _1 = "Pcxg0";
var _2 = "i0hr9";
var _3 = "msM_R";
export { _1 as "base", _2 as "description", _3 as "title" }
